<template>
  <div class="home">
    <tabbar></tabbar>
    <activitylist></activitylist>
  </div>
</template>
<script>
export default {
  name: 'home',
};
</script>



// WEBPACK FOOTER //
// src/pages/home.vue